import { useEffect, useState } from "react";
import api from "@/lib/api";
import LegalPage from "@/components/LegalPage";

export default function Privacidade() {
    const [c, setC] = useState(null);
    useEffect(() => {
        api.get("/pages/privacidade").then((r) => setC(r.data?.content)).catch(() => {});
    }, []);
    if (!c) return null;
    return (
        <LegalPage
            eyebrow={c.eyebrow || "Documentos"}
            title={c.title || "Política de privacidade"}
            lastUpdated={c.last_updated}
            testIdPrefix="privacy"
            sections={c.sections || []}
        />
    );
}
